export default __webpack_public_path__ + "static/media/logo.b7723a6e.jpg";